// modules
import { Provider } from 'react-redux'
// components
import { EmojiPickerBase } from '../components/main/emoji-picker-base'
import store from './redux'
import EmojiPickerRoot from '../components/main/emojiPicker.container'
import {
  dispatchToggleIsOpen,
  dispatchSetIsOpen,
} from '../components/main/emojiPicker.actions'

export const toggleEmojiPicker = () => dispatchToggleIsOpen()
export const closeEmojiPicker = () => dispatchSetIsOpen(false)

export { EmojiPickerBase }

function EmojiPicker(props: any) {
  return (
    <Provider store={store}>
      <EmojiPickerRoot {...props} />
    </Provider>
  )
}

export default EmojiPicker
